const getThemeColors = (theme, colorType) => {
  if (colorType === 'Primary') {
    switch (theme) {
      case 'Fashion':
        return '#fb586c'
      case 'WSI':
        return '#0F52BA'
      case 'Beauty':
        return '#000'
      case 'Moonshot':
        return '#ff8426'
      case 'Single':
        return '#39aea9'
      case 'Darknight':
        return '#FF60B7'
      case 'Zopnow':
      case 'White':
        return '#EB373A'
      case 'Ruby':
        return '#D0021B'
      case 'Emerald':
        return '#65A815'
      case 'Yellow':
        return '#FED330'
      case 'Sapphire':
        return '#126872'
      case 'Pharma':
        return '#00B690'
      case 'Getz':
        return '#009cde'
      case 'ZopStore':
        return '#0A1545'
      case 'Blaze':
        return '#20974F'
      case 'Glide':
        return '#E2BF53'
      case 'InkGlow':
        return '#E2BF53'
      default:
        return '#1FB9EA'
    }
  }
  if (colorType === 'Secondary') {
    switch (theme) {
      case 'WSI':
        return '#0a780f'
      case 'Beauty':
        return '#fb586c'
      case 'Moonshot':
        return '#f8f8f8'
      case 'Single':
        return '#DEF2F1'
      case 'Darknight':
        return '#121212'
      case 'Zopnow':
      case 'White':
        return '#FED400'
      case 'Pharma':
        return '#27487F'
      default:
        return '#6ab2ad'
    }
  }
}

export default getThemeColors
